import { AnalyticsMetaKeys as key } from '../../services/analytics/formatters/meta-keys'
import { Event , IEvent } from '../event/event'

export interface IAnalyticsEvent extends IEvent {
    setMetaProperties(metaProperties: any): void

    getProperties(): any
}

export class AnalyticsEvent extends Event implements IAnalyticsEvent {
    protected eventData: any

    protected commonAttrs = [
        key.CURRENT_PAGE,
        key.DEVICE_TYPE,
        key.PLATFORM,
        key.PLATFORM_VERSION,
        key.FEM_VERSION
    ]
    protected metaProperties: any

    /**
     * Set meta properties for use in any extended event
     *
     * @param metaProperties
     */
    public setMetaProperties(metaProperties: any): void {
        this.metaProperties = metaProperties
    }

    /**
     * Get the base properties for an event, safely parsing the value
     */
    public getProperties(): any {

        if (this.value && this.value.length && JSON.parse(this.value)) {
            return JSON.parse(this.value)
        }

        return undefined
    }

    /**
     *  Get event attributes List by combining common attributes and element data extra keys
     *
     * @returns string[]
     */
    public getAttributesList(): string[] {
        let attrs: string [] = []
        // Get Dom Event Data
        this.eventData = this.eventData || this.getProperties()

        if(this.eventData && this.eventData.control_fields) {
            // Exclude Keys from Common Attributes
            const excludeCommonKeys = this.eventData.control_fields.exclude_common_keys || []
            if(excludeCommonKeys.length > 0) {
                this.commonAttrs.forEach((commonAttr) => {
                    if (!excludeCommonKeys.includes(commonAttr)) {
                        attrs.push(commonAttr)
                    }
                })
            } else {
                attrs = [...this.commonAttrs]
            }

            // Add extra keys
            if(this.eventData.control_fields.extra_keys) {
                attrs = [...attrs ,...this.eventData.control_fields.extra_keys ]
            }
        } else {
            attrs = [...this.commonAttrs]
        }
        return attrs
    }

    /**
     *  Get Custom Attributes from event data element
     *
     * @return { [key: string]: string }
     */
    protected getCustomElementData(): { [key: string]: string } {
        const data: { [key: string]: string }= {}
        // Get Dom Event Data
        this.eventData = this.eventData || this.getProperties()
        if (this.eventData) {
            for (const eventAttr in this.eventData) {
                if (this.eventData.hasOwnProperty(eventAttr)) {
                    if(eventAttr !== 'control_fields') {
                        data[eventAttr] = String(this.eventData[eventAttr])
                    }
                }
            }
        }
        return data
    }

    /**
     * Get control field
     */
    protected getControlFields(): { [key: string]: string } {
        return this.eventData && this.eventData.control_fields? this.eventData.control_fields:{}
    }
}
